import { GeneralAPI } from '../apis/GeneralAPI'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import BookingSection from '../components/PestLanding/BookingSection'
import CampaignStrategy from '../components/PestLanding/CampaignStrategy'
import FAQ from '../components/PestLanding/FAQ'
import HowItWorks from '../components/PestLanding/HowItWorks'
import PestHero from '../components/PestLanding/PestHero'
import SocialProof from '../components/PestLanding/SocialProof'
import WhyOLM from '../components/PestLanding/WhyOLM'

const PEST_FALLBACK_META = `
<meta name="description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
<meta property="og:title" content="Direct Mail Marketing That Works" />
<meta property="og:description" content="Get higher response rates with targeted direct mail. Proven templates, fast turnaround, and expert coaching to help you close more deals." />
`

export default function Pest({ data }) {
    return (
        <LandingPageWrapper sectionSpacing={false} paddingFromTop={false}>
            <Header
                meta={data?.yoast_head || PEST_FALLBACK_META}
                metaTitle="Direct Mail Marketing That Works"
            />
            <PestHero />
            <SocialProof />
            <CampaignStrategy />
            <WhyOLM />
            <HowItWorks />
            <FAQ />
            <BookingSection />

            <style
                dangerouslySetInnerHTML={{
                    __html: `
                @media (max-width: 640px) {
                    .pest-form-grid {
                        grid-template-columns: 1fr !important;
                        padding: 20px !important;
                        gap: 16px !important;
                    }
                    .pest-form-footer {
                        justify-content: center !important;
                        text-align: center;
                    }
                    .pest-form-footer button {
                        width: 100%;
                    }
                }
            `,
                }}
            />
        </LandingPageWrapper>
    )
}

export async function getStaticProps() {
    let data = {}

    try {
        const page = await GeneralAPI.getPageBySlug('/pest')
        data = page ? page[0] || {} : {}
    } catch (e) {
        console.error(e)
    }

    try {
        const { banners } = await GeneralAPI.getACFBanners()
        data.banners = banners
    } catch (e) {
        console.error(e)
    }

    return {
        props: {
            data,
            hideCartButton: true,
            hideLoginButton: true,
            phoneNumber: '978-893-5890',
        },
        revalidate: 10,
    }
}
